import {
  FilterChip,
  FilterContainer,
  FilterLabel,
} from "./ComparePlans.styles";
import { IComparePlansFilter } from "./types";

interface FilterTabsProps {
  filters: IComparePlansFilter[];
  activeFilter: string;
  onFilterChange: (value: string) => void;
}

const FilterTabs = ({
  filters,
  activeFilter,
  onFilterChange,
}: FilterTabsProps) => {
  if (!filters.length) return null;

  return (
    <FilterContainer>
      <FilterLabel>Show:</FilterLabel>
      {filters.map((filter) => (
        <FilterChip
          key={filter.value}
          $active={activeFilter === filter.value}
          onClick={() => onFilterChange(filter.value)}
          aria-pressed={activeFilter === filter.value}
        >
          {filter.label}
        </FilterChip>
      ))}
    </FilterContainer>
  );
};

export default FilterTabs;
